/** @format */

import {makePictureTree} from 'filestack-adaptive';
import PropTypes from 'prop-types';
import React from 'react';

export const AdaptiveImage = ({
    sizes = {fallback: '100vw'},
    resolutions = false,
    width = false,
    imageClassName = '',
    src = '',
    ...props
}) => {
    const options = {
        sizes: sizes,
        cname: process.env.FILESTACK_CDN_URL?.replace('https://cdn.', '')
    };

    if (resolutions) {
        options.resolutions = resolutions;
    }

    if (width) {
        options.width = width;
    }

    if (src === '') {
        return null;
    }

    const tree = makePictureTree({apiKey: process.env.FILESTACK_KEY, srcHandle: src}, options);

    return (
        <picture {...props}>
            {tree.sources &&
                tree.sources.map(sourceObj => {
                    return <source {...sourceObj} className={imageClassName} />;
                })}
            {props.isMaxWidth && (
                <img
                    draggable={false}
                    {...tree.img}
                    style={{maxWidth: '100%'}}
                    className={imageClassName}
                />
            )}
            {!props.isMaxWidth && (
                <img draggable={false} {...tree.img} className={imageClassName} />
            )}
        </picture>
    );
};

AdaptiveImage.propTypes = {
    src: PropTypes.string.isRequired
};

// TODO: remove default export once all imports are updated
export default AdaptiveImage;
